/**
 * A copy of the error codes from Sentinel Link's APIs.
 * See: https://github.com/StoneAgeInc/stoneage-sentinel-api/blob/5ec287e8ab5fd2b6dbf8bf5c1c9e2b80ccdc816d/server/utils/errors.ts#L6
 */
export enum ErrorCode {
  InsufficientLicenses = 'ERR_INSUFFICIENT_LICENSES',
}
